'use client';

import { MetricItem, Text, Tooltip } from '@terra/ui-design-system';
import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';

type ComponentDetectionMetricProps = {
  label: string;
  icon: ReactNode;
  count: number;
  isUnavailable?: boolean;
};

export function ComponentDetectionMetric({
  label,
  icon,
  count,
  isUnavailable = false,
}: ComponentDetectionMetricProps) {
  const t = useTranslations('aiApplications.assets');

  if (isUnavailable) {
    return (
      <Tooltip title={t('metricsUnavailable')}>
        <Text fontSize="sm" color="fg.muted">
          —
        </Text>
      </Tooltip>
    );
  }

  return <MetricItem icon={icon} label={label} metrics={count} />;
}
